import axios from 'axios';
import { TIMESTAMP_OPTIONS, ATTRIBUTE_CONFIGS } from '../../constants/feedDataConstants';
import { buildMetrics } from '../../utils/feedDataUtils';
import { organizeFeedData } from '../../services/feedProcessors';

export const GET_FEED_DATA = 'GET_FEED_DATA';

export const getFeedDataAction = ({
	currentFeed,
	revenueFeed,
	remoteFeed,
	peopleFeed,
	fingerPrintFeed,
	keycardFeed,
}) => ({
	type: GET_FEED_DATA,
	currentFeed,
	revenueFeed,
	remoteFeed,
	peopleFeed,
	fingerPrintFeed,
	keycardFeed,
});

/**
 * Fetches feed data from Kairos API for all devices and feed types
 * Refactored to follow KISS, DRY, and SOLID principles
 *
 * @returns {Function} Redux thunk action
 */
export const getFeedData = () => async (dispatch, getState) => {
	const { fireStoreReducer, selectedFeedReducer } = getState();
	const { kairosUrl, userToken } = fireStoreReducer.fireStoreConfig;
	const { devices, range, breakdown } = selectedFeedReducer.selectedFeed;

	// Build metrics configuration for all devices and attributes
	const metrics = buildMetrics(devices, ATTRIBUTE_CONFIGS, breakdown);

	// Calculate query time range (start one period earlier to ensure data availability)
	const startTime = range.startDate - TIMESTAMP_OPTIONS[breakdown];
	const endTime = range.endDate;

	const queryData = {
		start_absolute: startTime,
		end_absolute: endTime,
		metrics,
	};

	try {
		// Fetch data from Kairos API
		const response = await axios({
			url: kairosUrl,
			method: 'post',
			headers: { Authorization: `Bearer ${userToken}` },
			data: queryData,
		});

		// Process and organize feed data
		const feedLists = organizeFeedData(response.data.queries, range);

		// Dispatch action with organized feed data
		dispatch(
			getFeedDataAction({
				currentFeed: feedLists.currentFeedList,
				revenueFeed: feedLists.revenueFeedList,
				remoteFeed: feedLists.remoteFeedList,
				peopleFeed: feedLists.peopleFeedList,
				fingerPrintFeed: feedLists.fingerPrintFeedList,
				keycardFeed: feedLists.keycardFeedList,
			})
		);
	} catch (error) {
		console.error('Error fetching feed data:', error);

		// Dispatch empty arrays on error
		dispatch(
			getFeedDataAction({
				currentFeed: [],
				revenueFeed: [],
				remoteFeed: [],
				peopleFeed: [],
				fingerPrintFeed: [],
				keycardFeed: [],
			})
		);
	}
};
